import {
  OpenUrlTarget,
  PanelContainer,
  openURL,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';

const PrivacyControlsModule: React.FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <PanelContainer
      defaultOpen={false}
      icon="key"
      panelTitle={isDesktop ? 'Privacy Controls' : 'Privacy Requests'}
      body="The California Consumer Privacy Act provides three new privacy rights to California residents relating to the access, deletion, or sale of their personal information. These rights are subject to the exceptions outlined in the CCPA."
      primaryCTA={{
        label: 'Learn More',
        onPress: () =>
          openURL(
            'https://www.caesars.com/corporate/corporate-social-responsibility/play/privacyrequests',
            OpenUrlTarget.BLANK
          ),
      }}>
      <View>
        <Text
          fontSize={isDesktop ? '16px' : '14px'}
          fontWeight="bold"
          marginBottom="16px">
          Access and Deletion Requests
        </Text>
        <Text
          fontSize={isDesktop ? '16px' : '14px'}
          lineHeight={isDesktop ? '26px' : '24px'}
          marginBottom={isDesktop ? '26px' : '24px'}>
          Access Requests: Under the CCPA, a Caesars Entertainment customer can
          request that we disclose to them, for the 12-month period preceding
          the date of the request, (i) the categories of personal information we
          have collected about them, (ii) the categories of sources from which
          personal information is collected, (iii) the business or commercial
          purpose for the information collection, (iv) the categories of third
          parties with whom we have shared personal information, and (v) the
          specific pieces of personal information we hold about them.
        </Text>
        <Text
          fontSize={isDesktop ? '16px' : '14px'}
          lineHeight={isDesktop ? '26px' : '24px'}>
          Deletion Requests: under the CCPA, a Caesars customer can request to
          have their personal information deleted, subject to certain
          exceptions.
        </Text>
      </View>
    </PanelContainer>
  );
};

export default PrivacyControlsModule;
